/**
 * SGIS 총조사 헤드라인 통계 조회 API 래퍼.
 * 백엔드: GET /sgis/census/summary (JWT 인증, PR #51).
 * apiClient(Ky) + 생성 타입(Sgis.*) 사용 — 기존 fuel-station-api 패턴과 동일.
 */

import { apiClient } from './api-client';
import { unwrap } from './unwrap';
import type { CensusSummaryResponse } from './api/data-contracts';

export type CensusSummary = CensusSummaryResponse;

/** 시도 전체 통계 목록 조회 */
export async function fetchSidoSummaries(year: number): Promise<CensusSummary[]> {
  return unwrap(
    await apiClient
      .get('sgis/census/summary', {
        searchParams: { level: 'SIDO', year },
      })
      .json<CensusSummary[]>()
  );
}

/**
 * 전국 시군구 통계 목록 조회 (252건, ~20KB).
 * 시도 스코프(parentAdmCd)로 조회하면 시도를 넘는 코드 보정(군위군 → 대구 22520)이
 * 응답에 없어 결측이 되므로 전국을 한 번에 받는다.
 */
export async function fetchSigunguSummaries(year: number): Promise<CensusSummary[]> {
  return unwrap(
    await apiClient
      .get('sgis/census/summary', {
        searchParams: { level: 'SIGUNGU', year },
      })
      .json<CensusSummary[]>()
  );
}

/**
 * 행정구역 코드(admCd) → 통계 Map 으로 정규화.
 * admCd 가 없는 항목은 건너뛴다.
 */
export function indexByAdmCd(summaries: CensusSummary[]): Map<string, CensusSummary> {
  const map = new Map<string, CensusSummary>();
  for (const s of summaries) {
    if (s.admCd) map.set(s.admCd, s);
  }
  return map;
}
